import {
    PURCHASE_INTREST_CALCULATION_REPORT_REQUEST,
    PURCHASE_INTREST_CALCULATION_REPORT_SUCCESS,
    PURCHASE_INTREST_CALCULATION_REPORT_FAILURE
} from '../types/purchase-intrest-calculation-report-types';

const initialState = {
    purchaseInterestCalculation: {},
    loading: false,
    data: null,
    error: null
};

const purchaseInterestCalculationReducer = (state = initialState, action) => {
    switch (action.type) {
        case PURCHASE_INTREST_CALCULATION_REPORT_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };
        case PURCHASE_INTREST_CALCULATION_REPORT_SUCCESS:
            console.log('Reducer received data:', action.payload);
            return {
                ...state,
                purchaseInterestCalculation: {...(action.payload || {})},
                loading: false,
                data: action.payload,
                error: null
            };
        case PURCHASE_INTREST_CALCULATION_REPORT_FAILURE:
            return {
                ...state,
                loading: false,
                data: null,
                error: action.payload
            };
        default:
            return state;
    }
};

export default purchaseInterestCalculationReducer;
